// Login gate. Resolves only once the user has a valid session (or auth is disabled).
import { api } from "../api";
import { $user } from "../store";

// Resolves with the user's role ("admin" = Viewport, "viewer" = client).
export async function ensureAuth(): Promise<string> {
  try {
    const me = await api.me(); // 200 if logged in or auth disabled
    $user.set(me.user ?? "");
    return me.role ?? "admin";
  } catch {
    // fall through to the login screen
  }
  return showLogin();
}

function showLogin(): Promise<string> {
  return new Promise((resolve) => {
    const overlay = document.createElement("div");
    overlay.className = "login-overlay";
    overlay.innerHTML = `
      <form class="login-card">
        <div class="login-logo">
          <svg viewBox="0 0 290 218" fill="#ff0037" width="44">
            <path d="M268.59,218.05L1.53,215.89c-1.2,0-1.93-1.34-1.29-2.36L133.86.72c.6-.96,2.01-.96,2.61,0l133.44,214.97c.64,1.03-.11,2.36-1.32,2.35ZM31.92,199.25l206.17,1.66c1.21,0,1.96-1.32,1.32-2.35L136.39,32.61c-.6-.97-2-.97-2.61,0L30.63,196.9c-.64,1.02.09,2.35,1.29,2.36Z"/>
            <path d="M283.15,194.34l-221.45-21.92c-.93-.09-1.4-1.17-.84-1.92L188.59,2.22c.54-.71,1.64-.6,2.03.19l93.72,190.21c.42.84-.26,1.82-1.19,1.72ZM87.06,161.36l173.23,17.15c.94.09,1.61-.88,1.19-1.72L188.17,27.99c-.39-.8-1.49-.9-2.03-.19l-99.91,131.64c-.57.75-.1,1.83.84,1.92Z"/>
            <path d="M289.64,178.34l-174.9-37.89c-.82-.18-1.14-1.19-.56-1.8L229.98,16.27c.55-.58,1.53-.38,1.8.37l59.11,160.27c.3.8-.41,1.61-1.25,1.43ZM134.46,134.36l139.29,30.17c.84.18,1.54-.63,1.25-1.43l-47.08-127.64c-.28-.75-1.25-.95-1.8-.37l-92.22,97.47c-.58.61-.27,1.62.56,1.8Z"/>
          </svg>
        </div>
        <div class="login-title">GEAAR Review Station</div>
        <input class="login-input" name="u" type="text" placeholder="Username" autocomplete="username" autofocus />
        <input class="login-input" name="p" type="password" placeholder="Password" autocomplete="current-password" />
        <button class="login-btn" type="submit">Sign in</button>
        <div class="login-err"></div>
      </form>`;
    document.body.append(overlay);
    const form = overlay.querySelector("form")!;
    const err = overlay.querySelector<HTMLDivElement>(".login-err")!;
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const u = (form.elements.namedItem("u") as HTMLInputElement).value.trim();
      const p = (form.elements.namedItem("p") as HTMLInputElement).value;
      err.textContent = "";
      try {
        const res = await api.login(u, p);
        $user.set(res.user ?? u);
        overlay.remove();
        resolve(res.role ?? "viewer");
      } catch (ex) {
        err.textContent = (ex as Error).message || "Login failed";
      }
    });
  });
}
